import { render, staticRenderFns } from "./SpeciesPriority.vue?vue&type=template&id=2a305e84&scoped=true&"
import script from "./SpeciesPriority.vue?vue&type=script&lang=js&"
export * from "./SpeciesPriority.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesPriority.vue?vue&type=style&index=0&id=2a305e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a305e84",
  null
  
)

export default component.exports